// Root Saga
import { all, fork } from 'redux-saga/effects';
import loadTestSaga from './test';
import loadSubmitSaga from './submit';
import loadSectionsSaga from './sections';
import loadAuthSaga from './auth';
import loadSocketSaga from './socket';
import loadProctorSaga from './proctor';
import eventTrackingSaga from './eventTracking';
import onboarding from './onboarding';
import report from './report';
import coding from './coding';
import desmond from './desmond';
import playgroundSaga from './playGround';
import datascienceJupyterSaga from './datascienceJupyter';
import infraAllocationSaga from './infra';
import podBasedSaga from './podBased';
import loadWhitelabelSaga from './whitelabel.saga';
import loadAiInterviewSaga from './aiInterview';

function* rootSaga() {
  yield all([
    fork(loadTestSaga),
    fork(loadSubmitSaga),
    fork(loadSectionsSaga),
    fork(loadAuthSaga),
    fork(loadProctorSaga),
    fork(eventTrackingSaga),
    fork(onboarding),
    fork(loadSocketSaga),
    fork(report),
    fork(coding),
    fork(desmond),
    fork(datascienceJupyterSaga),
    fork(playgroundSaga),
    fork(infraAllocationSaga),
    fork(podBasedSaga),
    fork(loadWhitelabelSaga),
    fork(loadAiInterviewSaga),
  ]);
}

export default rootSaga;
